<template>
  <div class="container">
    <van-sticky>
      <van-nav-bar
        title="金币提现"
        right-text="提现规则"
        left-arrow
        @click-left="goBack"
        @click-right="onClickRight"
      />
    </van-sticky>
    <div class="page">
      <div class="card">
        <div class="head">
          <h2>可提现金额（元）</h2>
          <h3>{{ accountInfo.withdrawalAmount }}</h3>
          <div class="recond"><span @click="seeRecord">提现记录</span></div>
        </div>
        <div class="card-bottom" v-if="bindAccountList.length === 0">
          <img src="@/assets/images/gold-coin/no_head.png" alt="" />
          <div class="bind">
            <span @click="goAccount">立即绑定提现账户 ></span>
          </div>
        </div>
        <div class="card-bottom" v-else>
          <img :src="bindAccount.headImgUrl" alt="" />
          <div class="bind">
            <span @click="goAccount">查看提现账户</span>
          </div>
        </div>
      </div>
    </div>
    <div class="kong"></div>
    <div class="meony">
      <div class="withdraw">
        <div class="input-meony">
          <!-- <span>￥</span> -->
          <van-field
            v-model="amount"
            label="￥"
            placeholder="请输入提现金额"
            type="number"
          />
        </div>
        <div class="all" @click="all">全部</div>
      </div>
      <div class="amount">
        <div class="amount-deatils">
          <span>将扣除金币数目：{{ gold }}个</span>
          <img src="@/assets/images/gold-coin/gong_gold.png" alt="" />
        </div>
        <!-- <div><span>将扣除金币数目：--</span></div> -->
      </div>
      <div class="rule">
        <h3>结算规则：</h3>
        <p>
          1、目前最低提现金额为1元，最高5000元，请确认提现输入金额是否超限；
        </p>
        <p>2、100元以上，当日到账；100元以上，T+1到账；</p>
        <p>3、每天最多可提现4次。</p>
      </div>
    </div>
    <div class="bottom-btn">
      <van-button size="normal" @click="confirm">确认提现</van-button>
    </div>
    <div>
      <van-dialog v-model="successShow" title="提现成功" >
        <div class="success-show">
         <p>已提现 <span>{{amount}}</span>元至您绑定账户</p>
           <img src="@/assets/images/gold-coin/hbao.png" />
        </div>
      </van-dialog>
    </div>
  </div>
</template>

<script>
const Decimal = require('decimal.js')
import { account, withdraw, bindAccounts } from '@/api/gold-coin'
export default {
  data() {
    return {
      successShow:false,
      accountInfo: '',
      bindAccount: '',
      bindAccountList: [],
      amount: '',
    }
  },
  computed: {
    gold() {
      if (this.amount) {
        return new Decimal(this.amount * 125).toDecimalPlaces(
          0,
          Decimal.ROUND_UP
        )
      } else {
        return '0'
      }
    },
  },
  created() {
    this.getAccountInfo()
    this.getBindAccountsInfo()
  },
  methods: {
    getAccountInfo() {
      account().then(({ data }) => {
        if (data.code === 200) {
          this.accountInfo = data.data
          console.log('data', data.data)
        }
      })
    },
    getBindAccountsInfo() {
      bindAccounts().then(({ data }) => {
        if (data.code === 200) {
          this.bindAccount = data.data[0]
          this.bindAccountList = data.data
          console.log('bind', data.data)
        }
      })
    },
    goBack() {
      if (this.$getIsApp()) {
        this.$callApp('Android', 'GoBackAppMethod', '')
        this.$callApp('iOS', 'GoBackAppMethod', '')
      } else {
        this.$router.go(-1)
      }
    },
    onClickRight() {
      this.$router.push({
        path: '/gold-coin/withdrawal-explain',
      })
    },
    seeRecord() {
      this.$router.push({
        path: '/gold-coin/withdraw-record',
      })
    },
    all() {
      this.amount = this.accountInfo.withdrawalAmount
    },
    goAccount() {
      this.$router.push({
        path: '/gold-coin/bind-account',
      })
    },
    confirm() {
      if (this.amount === 0 || this.amount === '') {
        this.$toast('请输入提现金额')
        return
      }

      if (this.bindAccountList.length === 0) {
        this.$toast('请先绑定微信账户再提现')
        return
      }

      this.$dialog
        .confirm({
          title: '提示',
          message: '确定提现吗',
        })
        .then(() => {
          withdraw({ amount: this.amount }).then(({ data }) => {
            if (data.code === 200) {
              if (data.data.success) {
                this.successShow=true
                this.getAccountInfo()
                this.getBindAccountsInfo()
              } else {
                this.$router.push({
                  path: '/gold-coin/withdraw-process',
                  query: {
                    amount: this.amount,
                    nickname: this.bindAccount.nickname,
                    reason: data.data.reason,
                  },
                })
              }
            } else {
              this.$toast(data.message)
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    },
  },
}
</script>

<style lang="less" scoped>
// .container{
//   min-height: 100vh;
//   background: #efefef;
// }
.page {
  height: 137px;
  background: linear-gradient(180deg, #ff4059 0%, #ff7e6c 100%);
  opacity: 1;
  padding: 20px 13px 0 13px;
}
.card {
  padding: 12px;

  height: 160px;
  background: #ffffff;
  box-shadow: 1px 1px 1px rgba(183, 183, 183, 0.75);
  opacity: 1;
  border-radius: 8px;
  .head {
    position: relative;
    text-align: center;
    h2 {
      margin: 5px 0;

      font-size: 16px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 23px;
      color: #985d1f;
    }
    h3 {
      margin: 15px 0;

      font-size: 30px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 42px;
      color: #323233;
    }
    .recond {
      position: absolute;
      right: 0;
      top: 0;
      span {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 20px;
        color: #0099cc;
      }
    }
  }
}
.card-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // padding: 15px 0px 0 0;
  img {
    width: 50px;
    height: 50px;
    background: rgba(0, 0, 0, 0);
    border: 1px solid #c8c9cc;
    border-radius: 50%;
    opacity: 1;
  }
  .bind {
    span {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 11px;
      color: #ee0a24;
    }
  }
}
.kong {
  height: 80px;
  border-bottom: 5px solid #f4f4f4;
}
.meony {
  .withdraw {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #ebedf0;
    padding-bottom: 15px;
  }

  padding: 20px;

  .input-meony {
    width: 300px;
    display: flex;
    align-items: center;
    /deep/ .van-cell {
      padding: 0;
    }
    /deep/.van-field__label {
      width: 20px;

      font-size: 30px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 42px;
      color: #323233;
    }
    /deep/.van-field__control {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 28px;
      color: #323233;
    }
    /deep/ .van-field__body {
      padding-top: 10px;
    }
  }
  .all {
    padding-top: 10px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 23px;
    color: #0099cc;
  }
}
.amount {
  border-bottom: 1px solid #ebedf0;

  padding: 15px 0;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 23px;
  color: #0099cc;
  img {
    margin: 0 5px;
    width: 25px;
    height: 25px;
    background: rgba(0, 0, 0, 0);
    opacity: 1;
  }
  .amount-deatils {
    display: flex;
    align-items: center;
  }
}
.rule {
  h3 {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 23px;
    color: #323233;
  }
  p {
    margin: 2px 0;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 21px;
    color: #323233;
  }
}
.bottom-btn {
  text-align: center;
  padding: 15px 0;
  // background: #f4f4f4;
  opacity: 1;
  /deep/.van-button--normal {
    width: 200px;
    height: 50px;
    background: #fedfdd;
    opacity: 1;
    border-radius: 5px;

    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 11px;
    color: #ee0a24;
  }
}
.success-show{
  text-align: center;
  p{
    margin:10px 0;
  }
  span{
    color:#F15100;
  }
  img{
    width: 160px;
    height: 120px;
  }
}
</style>